export const translations = {
  English: {
    // Sidebar
    nav_home: 'Home',
    nav_favorites: 'Favorites',
    nav_submit: 'Submit Tool',
    nav_picks: 'AI Tools Picks',
    nav_contact: 'Contact Us',
    nav_about: 'About',
    nav_blog: 'Blog',
    nav_admin: 'Admin Dashboard',

    // Footer - CTA
    footer_ready_title: 'Ready to supercharge your workflow?',
    footer_ready_desc: 'Join thousands of professionals already using AI Tools Hub to discover the best tools and grow their productivity.',
    footer_start_trial: 'Start Free Trial',
    footer_upgrade: 'Upgrade',
    footer_contact_sales: 'Contact Sales',
    footer_no_setup: 'No setup fees',
    footer_cancel_anytime: 'Cancel anytime',
    
    // Footer - Links
    footer_product: 'Product',
    footer_pricing: 'Pricing',
    footer_showcase: 'Showcase',
    footer_history: 'History',
    
    footer_support: 'Support',
    footer_help: 'Help Center',
    footer_terms: 'Terms of Service',
    footer_privacy: 'Privacy Policy',

    // Footer - Newsletter
    footer_get_updates: 'Get Updates',
    footer_updates_desc: 'Latest AI tools and trends sent to your inbox weekly.',
    footer_enter_email: 'Enter your email',
    footer_subscribe: 'Subscribe',
    footer_subscribed: 'Subscribed',

    // Hero
    hero_title_prefix: 'Discover the perfect AI tools for your',
    hero_phrases: [
      'Coding Assistants', 'AI Chatbots', 'Video Generators', 'Writing Tools',
      'Presentation Tools', 'Marketing Tools', 'Voice Tools', 'Website Builders',
      'Image Generators', 'Email Assistance', 'Spreadsheet Tools', 'Music Generators'
    ],
    
    // Search
    search_placeholder_mobile: 'Search AI tools...',
    search_placeholder_desktop: 'Search All AI tools and collections...',

    // Tool Detail
    tool_visit: 'Visit Site',
    tool_save: 'Save',
    tool_saved: 'Saved',
    tool_share: 'Share',
    tool_share_alert: 'Link copied to clipboard!',
    tool_about: 'About',
    tool_faq: 'Questions & Answers',
    tool_info: 'Tool Information',
    tool_more_like: 'More Tools Like This',
    label_category: 'Category',
    label_pricing: 'Pricing',
    label_added: 'Added On',
    label_platform: 'Platform',
    label_features: 'Key Features',
    
    // Common
    back_home: 'Back to Home',
    go_back: 'Go Back',
    tool_not_found: 'Tool Not Found',
    tool_not_found_desc: "The tool you're looking for doesn't exist or has been removed from our database.",
  },
  Hindi: {
    // Sidebar
    nav_home: 'होम',
    nav_favorites: 'पसंदीदा',
    nav_submit: 'टूल सबमिट करें',
    nav_picks: 'AI टूल्स पिक्स',
    nav_contact: 'संपर्क करें',
    nav_about: 'हमारे बारे में',
    nav_blog: 'ब्लॉग',
    nav_admin: 'एडमिन डैशबोर्ड',

    // Footer - CTA
    footer_ready_title: 'अपने वर्कफ़्लो को सुपरचार्ज करने के लिए तैयार हैं?',
    footer_ready_desc: 'हजारों पेशेवरों के साथ जुड़ें जो पहले से ही बेहतरीन टूल्स खोजने और उत्पादकता बढ़ाने के लिए AI Tools Hub का उपयोग कर रहे हैं।',
    footer_start_trial: 'निःशुल्क परीक्षण शुरू करें',
    footer_upgrade: 'अपग्रेड करें',
    footer_contact_sales: 'बिक्री टीम से संपर्क करें',
    footer_no_setup: 'कोई सेटअप शुल्क नहीं',
    footer_cancel_anytime: 'कभी भी रद्द करें',

    // Footer - Links
    footer_product: 'उत्पाद',
    footer_pricing: 'मूल्य निर्धारण',
    footer_showcase: 'शोकेस',
    footer_history: 'इतिहास',
    
    footer_support: 'सहायता',
    footer_help: 'सहायता केंद्र',
    footer_terms: 'सेवा की शर्तें',
    footer_privacy: 'गोपनीयता नीति',

    // Footer - Newsletter
    footer_get_updates: 'अपडेट प्राप्त करें',
    footer_updates_desc: 'नवीनतम AI टूल्स और ट्रेंड्स साप्ताहिक आपके इनबॉक्स में।',
    footer_enter_email: 'अपना ईमेल दर्ज करें',
    footer_subscribe: 'सदस्यता लें',
    footer_subscribed: 'सदस्यता ली गई',

    // Hero
    hero_title_prefix: 'अपने लिए बेहतरीन AI टूल्स खोजें',
    hero_phrases: [
        'कोडिंग असिस्टेंट', 'AI चैटबॉट', 'वीडियो जनरेटर', 'लेखन टूल्स',
        'प्रेजेंटेशन टूल्स', 'मार्केटिंग टूल्स', 'वॉयस टूल्स', 'वेबसाइट बिल्डर्स',
        'इमेज जनरेटर', 'ईमेल सहायता', 'स्प्रेडशीट टूल्स', 'म्यूजिक जनरेटर'
    ],

    // Search
    search_placeholder_mobile: 'AI टूल्स खोजें...',
    search_placeholder_desktop: 'सभी AI टूल्स और संग्रह खोजें...',

    // Tool Detail
    tool_visit: 'साइट पर जाएं',
    tool_save: 'सहेजें',
    tool_saved: 'सहेजा गया',
    tool_share: 'शेयर करें',
    tool_share_alert: 'लिंक क्लिपबोर्ड पर कॉपी हो गया!',
    tool_about: 'के बारे में',
    tool_faq: 'प्रश्न और उत्तर',
    tool_info: 'टूल जानकारी',
    tool_more_like: 'इस जैसे और टूल्स',
    label_category: 'श्रेणी',
    label_pricing: 'मूल्य',
    label_added: 'जोड़ा गया',
    label_platform: 'प्लेटफ़ॉर्म',
    label_features: 'मुख्य विशेषताएं',

    // Common
    back_home: 'होम पर वापस जाएं',
    go_back: 'वापस जाएं',
    tool_not_found: 'टूल नहीं मिला',
    tool_not_found_desc: "जो टूल आप ढूंढ रहे हैं वह मौजूद नहीं है या हमारे डेटाबेस से हटा दिया गया है।",
  },
  Kannada: {
    // Sidebar
    nav_home: 'ಮುಖಪುಟ',
    nav_favorites: 'ಮೆಚ್ಚಿನವುಗಳು',
    nav_submit: 'ಟೂಲ್ ಸಲ್ಲಿಸಿ',
    nav_picks: 'AI ಟೂಲ್ಸ್ ಆಯ್ಕೆಗಳು',
    nav_contact: 'ಸಂಪರ್ಕಿಸಿ',
    nav_about: 'ನಮ್ಮ ಬಗ್ಗೆ',
    nav_blog: 'ಬ್ಲಾಗ್',
    nav_admin: 'ಅಡ್ಮಿನ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',

    // Footer - CTA
    footer_ready_title: 'ನಿಮ್ಮ ಕೆಲಸದ ವೇಗವನ್ನು ಹೆಚ್ಚಿಸಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
    footer_ready_desc: 'ಉತ್ತಮ ಟೂಲ್‌ಗಳನ್ನು ಹುಡುಕಲು ಮತ್ತು ಉತ್ಪಾದಕತೆಯನ್ನು ಹೆಚ್ಚಿಸಲು ಈಗಾಗಲೇ AI Tools Hub ಬಳಸುತ್ತಿರುವ ಸಾವಿರಾರು ವೃತ್ತಿಪರರೊಂದಿಗೆ ಸೇರಿಕೊಳ್ಳಿ.',
    footer_start_trial: 'ಉಚಿತ ಪ್ರಯೋಗ ಪ್ರಾರಂಭಿಸಿ',
    footer_upgrade: 'ಅಪ್‌ಗ್ರೇಡ್',
    footer_contact_sales: 'ಮಾರಾಟ ತಂಡವನ್ನು ಸಂಪರ್ಕಿಸಿ',
    footer_no_setup: 'ಯಾವುದೇ ಸೆಟಪ್ ಶುಲ್ಕವಿಲ್ಲ',
    footer_cancel_anytime: 'ಯಾವಾಗ ಬೇಕಾದರೂ ರದ್ದುಗೊಳಿಸಿ',

    // Footer - Links
    footer_product: 'ಉತ್ಪನ್ನ',
    footer_pricing: 'ದರಗಳು',
    footer_showcase: 'ಪ್ರದರ್ಶನ',
    footer_history: 'ಇತಿಹಾಸ',
    
    footer_support: 'ಬೆಂಬಲ',
    footer_help: 'ಸಹಾಯ ಕೇಂದ್ರ',
    footer_terms: 'ಸೇವಾ ನಿಯಮಗಳು',
    footer_privacy: 'ಗೌಪ್ಯತಾ ನೀತಿ',

    // Footer - Newsletter
    footer_get_updates: 'ಅಪ್‌ಡೇಟ್ ಪಡೆಯಿರಿ',
    footer_updates_desc: 'ಇತ್ತೀಚಿನ AI ಟೂಲ್ಸ್ ಮತ್ತು ಟ್ರೆಂಡ್ಸ್ ವಾರಕ್ಕೊಮ್ಮೆ ನಿಮ್ಮ ಇನ್‌ಬಾಕ್ಸ್‌ನಲ್ಲಿ.',
    footer_enter_email: 'ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ',
    footer_subscribe: 'ಚಂದಾದಾರರಾಗಿ',
    footer_subscribed: 'ಚಂದಾದಾರರಾಗಿದ್ದೀರಿ',

    // Hero
    hero_title_prefix: 'ನಿಮ್ಮ ಅಗತ್ಯಕ್ಕೆ ತಕ್ಕ AI ಟೂಲ್‌ಗಳನ್ನು ಹುಡುಕಿ',
    hero_phrases: [
        'ಕೋಡಿಂಗ್ ಸಹಾಯಕ್', 'AI ಚಾಟ್‌ಬಾಟ್', 'ವೀಡಿಯೊ ಜನರೇಟರ್', 'ಬರವಣಿಗೆ ಟೂಲ್ಸ್',
        'ಪ್ರಸ್ತುತಿ ಟೂಲ್ಸ್', 'ಮಾರ್ಕೆಟಿಂಗ್ ಟೂಲ್ಸ್', 'ಧ್ವನಿ ಟೂಲ್ಸ್', 'ವೆಬ್‌ಸೈಟ್ ಬಿಲ್ಡರ್ಸ್',
        'ಚಿತ್ರ ಜನರೇಟರ್', 'ಇಮೇಲ್ ಸಹಾಯ', 'ಸ್ಪ್ರೆಡ್‌ಶೀಟ್ ಟೂಲ್ಸ್', 'ಸಂಗೀತ ಜನರೇಟರ್'
    ],

    // Search
    search_placeholder_mobile: 'AI ಟೂಲ್‌ಗಳನ್ನು ಹುಡುಕಿ...',
    search_placeholder_desktop: 'ಎಲ್ಲಾ AI ಟೂಲ್‌ಗಳನ್ನು ಹುಡುಕಿ...',

    // Tool Detail
    tool_visit: 'ವೆಬ್‌ಸೈಟ್‌ಗೆ ಭೇಟಿ ನೀಡಿ',
    tool_save: 'ಉಳಿಸಿ',
    tool_saved: 'ಉಳಿಸಲಾಗಿದೆ',
    tool_share: 'ಹಂಚಿಕೊಳ್ಳಿ',
    tool_share_alert: 'ಲಿಂಕ್ ಕ್ಲಿಪ್‌ಬೋರ್ಡ್‌ಗೆ ನಕಲಿಸಲಾಗಿದೆ!',
    tool_about: 'ಬಗ್ಗೆ',
    tool_faq: 'ಪ್ರಶ್ನೆಗಳು ಮತ್ತು ಉತ್ತರಗಳು',
    tool_info: 'ಟೂಲ್ ಮಾಹಿತಿ',
    tool_more_like: 'ಇದೇ ರೀತಿಯ ಟೂಲ್‌ಗಳು',
    label_category: 'ವರ್ಗ',
    label_pricing: 'ಬೆಲೆ',
    label_added: 'ಸೇರಿಸಲಾಗಿದೆ',
    label_platform: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್',
    label_features: 'ಪ್ರಮುಖ ವೈಶಿಷ್ಟ್ಯಗಳು',

    // Common
    back_home: 'ಮುಖಪುಟಕ್ಕೆ ಹಿಂತಿರುಗಿ',
    go_back: 'ಹಿಂದೆ ಹೋಗಿ',
    tool_not_found: 'ಟೂಲ್ ಕಂಡುಬಂದಿಲ್ಲ',
    tool_not_found_desc: "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಟೂಲ್ ಅಸ್ತಿತ್ವದಲ್ಲಿಲ್ಲ ಅಥವಾ ನಮ್ಮ ಡೇಟಾಬೇಸ್‌ನಿಂದ ತೆಗೆದುಹಾಕಲಾಗಿದೆ.",
  }
};
